import {NgModule} from "@angular/core";
import {CommonModule, NgOptimizedImage} from "@angular/common";
import {HomeRoutingModule} from "../modules/home/home-routing.module";
import {SpinnerComponent} from "./components/spinner/spinner.component";
import {NavbarComponent} from "./components/navbar/navbar.component";
import {PhotoDialogComponent} from "./components/photo/photo/photo-dialog.component";
import {ShowPhotoDialogComponent} from "./components/photo/show-photo/show-photo-dialog.component";
import {MatFormFieldModule} from "@angular/material/form-field";
import {FormsModule} from "@angular/forms";
import {MatInputModule} from "@angular/material/input";

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    HomeRoutingModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    NgOptimizedImage
  ],
  exports: []
})
export class SharedModule {
}
